import { useCallback } from 'react'
import { useSetAtom, useStore } from 'jotai'
import * as Sentry from '@sentry/electron/renderer'

import {
  forYouLingerAtom,
  retireSharedCountdownChatsAtom,
  sharedCountdownChatIdsAtom,
} from '@renderer/overlay/hooks/for-you-linger-state'
import { useClearForYouChat } from '@renderer/overlay/hooks/use-clear-for-you-chat'
import type { SendClearedTodos } from './reminder-linger'
import { useReminderActions } from './use-reminders'

export function useSendClearedTodos(): SendClearedTodos {
  const { sendHeldTicks } = useReminderActions()
  const { clearForYouChat } = useClearForYouChat()
  const retireChats = useSetAtom(retireSharedCountdownChatsAtom)
  const setLingers = useSetAtom(forYouLingerAtom)
  const store = useStore()

  return useCallback(
    (ids) => {
      const heldChatIds = store.get(sharedCountdownChatIdsAtom)
      const chatIds = [...ids].filter((id) => heldChatIds.has(id))
      retireChats(new Set(chatIds))
      for (const id of chatIds) {
        clearForYouChat(id).catch((error) => {
          // Restore the row when archiving fails.
          setLingers((previous) => {
            const next = new Map(previous)
            next.delete(id)
            return next
          })
          Sentry.captureException(error)
        })
      }
      sendHeldTicks([...ids].filter((id) => !heldChatIds.has(id)))
    },
    [clearForYouChat, retireChats, sendHeldTicks, setLingers, store],
  )
}
